<template>
  <!-- 平台展示+预约+开通按钮 -->
  <div class="platform">
    <div class="vip_icon">
      <img alt src="../img/top-vip-icon.png" />
    </div>

    <div class="platform_display">
      <div class="display_inner">
        <div class="display_layout_top">
          <div class="kuaikan_icon_container">
            <img class="kuaikan_icon_bg" src="../img/kuaikan-icon-bg.png" />
            <img class="kuaikan_icon" src="../img/kuaikan-icon.png" />
          </div>
          <div class="slogan_container">
            <div class="slogan_icon">
              <img src="../img/slogan_icon.png" alt />
            </div>

            <div class="progress_container">
              <!-- 预约期 -->
              <div class="slogan_tips" v-show="activity_status == 1">
                11月6日&nbsp;11:30限量开抢&nbsp;售完为止
              </div>
              <!-- 开通期 -->
              <div class="progress_wrap" v-show="activity_status == 2">
                <div class="progress_inner" v-show="sale_count != 0"></div>
                <div class="got_num">已抢{{ sale_count }}份</div>
                <div class="left_num">
                  剩余{{
                    parseInt(((total_count - sale_count) / total_count) * 100)
                  }}%
                </div>
              </div>
              <!-- 领取期 -->
              <div class="progress_wrap" v-show="activity_status == 3">
                <div class="progress_inner progress_end"></div>
                <div class="left_num">已抢光</div>
              </div>
            </div>

            <!-- 9家 -->
            <div class="platform_tips" v-show="show_nine">
              会员数量有限 以购买时实际赠送为准
            </div>
            <!-- 10家 -->
            <div class="platform_tips" v-show="!show_nine">
              额外赠送QQ超级会员 数量有限 送完为止
            </div>
          </div>
        </div>
        <div class="display_layout_bottom">
          <!-- 9家平台 -->
          <div class="display_layout_inner_nine" v-if="show_nine">
            <div
              class="display_item"
              v-for="(item, index) in plat_icons"
              :key="index"
              v-show="index < 9"
            >
              <img class="display_icon" :src="item.award_icon" alt />
              <div class="plat_title">{{ item.award_title }}</div>
              <div class="plat_desc">{{ item.award_desc }}</div>
            </div>
          </div>
          <!-- 10家平台 -->
          <div class="display_layout_inner_ten" v-if="!show_nine">
            <div class="inner_ten_top">
              <div class="inner_ten_top_item" v-if="plat_icons[0] != undefined">
                <div class="inner_ten_icon">
                  <img :src="plat_icons[0].award_icon" />
                </div>
                <div class="inner_ten_info">
                  <div class="inner_ten_title">
                    {{ plat_icons[0].award_title }}
                  </div>
                  <div class="inner_ten_desc">
                    {{ plat_icons[0].award_desc }}
                  </div>
                </div>
              </div>
              <div class="inner_ten_top_item" v-if="plat_icons[1] != undefined">
                <div class="inner_ten_icon">
                  <img :src="plat_icons[1].award_icon" />
                </div>
                <div class="inner_ten_info">
                  <div class="inner_ten_title">
                    {{ plat_icons[1].award_title }}
                  </div>
                  <div class="inner_ten_desc">
                    {{ plat_icons[1].award_desc }}
                  </div>
                </div>
              </div>
            </div>
            <div class="inner_ten_bottom">
              <div
                class="inner_ten_bottom_item"
                v-for="(item, index) in plat_icons"
                :key="index"
                v-show="index > 1"
              >
                <div class="inner_ten_bottom_icon">
                  <img :src="item.award_icon" />
                </div>
                <div class="inner_ten_bottom_info">
                  <div class="inner_ten_bottom_title">
                    {{ item.award_title }}
                  </div>
                  <div class="inner_ten_bottom_desc">{{ item.award_desc }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 预约提醒+开通按钮+领取权益 -->
      <div class="open_btn">
        <open-btn :from="btn_from"></open-btn>
      </div>

      <div class="tips_container" v-show="activity_status == 2">
        <div class="left_tips">*每人限开通4次&nbsp;售完为止</div>
        <div class="right_time">活动倒计时：{{ remain_time }}</div>
        <!-- <div class="right_time">{{ remain_time }}</div> -->
      </div>
      <div class="tips_container tips_center" v-show="activity_status == 1">
        {{ sale_count }}人已预约抢购
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

//comp
import OpenBtn from "./OpenBtn";

const { log } = console;

export default {
  data() {
    return {
      remain_time: "-天-时-分-秒",

      btn_from: "platform", // 埋点用按钮来源
    };
  },
  computed: {
    ...mapState([
      "activity_status",
      "total_count",
      "sale_count",
      "plat_icons",
      "server_time",
      "activity_end_time",
      "comp_init",
      "progress_width",
      "show_nine",
    ]),
    // first_icon: function () {
    //   return this.plat_icons[0].award_icon;
    // },
    // second_icon: function () {
    //   return 1;
    // },
  },
  watch: {
    comp_init: function () {
      if (this.comp_init) {
        this.countDown();
        // this.progressWidth();
      }
    },
    // 骨架屏消失后进度条开始增长
    progress_width: function () {
      if (this.progress_width) {
        setTimeout(() => {
          this.progressWidth();
        }, 200);
      }
    },
  },
  components: {
    OpenBtn,
  },
  mounted: function () {},
  methods: {
    ...mapMutations(["SET_TIME_END", "SET_REFRESH_DATA"]),
    progressWidth() {
      if (this.activity_status == 1) {
        return false;
      }
      setTimeout(() => {
        let stop_width = (this.sale_count / this.total_count) * 100;
        // let stop_width = 100;
        let stop_up = true;
        document.querySelector(".progress_inner").style.width =
          stop_width + "%";

        // 在95进度的时候句取消动画，防止诡异的颤动效果
        // if (stop_width >= 95 || this.activity_status != 2) {
        if (stop_width >= 95) {
          // stop_width = 100;
          return false;
        }
        setTimeout(() => {
          setInterval(() => {
            if (stop_up) {
              stop_width += 0.8;
              stop_up = false;
            } else {
              stop_width -= 0.8;
              stop_up = true;
            }
            document.querySelector(".progress_inner").style.width =
              stop_width + "%";
          }, 500);
        }, 500);
      }, 500);
    },

    // 倒计时
    countDown() {
      let timer;
      let time_now = this.server_time;
      let time_end = this.activity_end_time;
      // let time_now = 1602968400000;
      // let time_end = 1602968410000;
      let diff = time_end - time_now;

      let day = Math.floor(diff / 1000 / 60 / 60 / 24),
        hour = Math.floor((diff / 1000 / 60 / 60) % 24),
        minute = Math.floor((diff / 1000 / 60) % 60),
        second = Math.floor((diff / 1000) % 60);

      // //第一次立即赋值
      this.remain_time = `${this.formateDate(day)}天${this.formateDate(
        hour
      )}时${this.formateDate(minute)}分${this.formateDate(second)}秒`;

      timer = setInterval(() => {
        if (day != 0 || hour != 0 || minute != 0 || second != 0) {
          if (second != 0) {
            //秒不为0时，秒自动减1
            second--;
          } else {
            //秒为0，查看分钟
            second = 59;
            if (minute != 0) {
              //秒为0，分钟不为0
              minute--;
            } else {
              //秒为0，分钟也为0
              minute = 59;
              if (hour != 0) {
                //秒为0，分钟也为0,小时不为0
                hour--;
              } else {
                hour = 23;
                //秒为0，分钟也为0,小时为0,日不为0
                if (day != 0) {
                  day--;
                } else {
                  day = 0;
                }
              }
            }
          }
          this.remain_time = `${this.formateDate(day)}天${this.formateDate(
            hour
          )}时${this.formateDate(minute)}分${this.formateDate(second)}秒`;
        } else if (hour == 0 && minute == 0 && second == 0) {
          //时间到
          log("时间到--");
          this.SET_TIME_END(true);
          this.SET_REFRESH_DATA(true);
          window.clearInterval(timer);
        }
      }, 1000);
    },
    // 时间2位数补位
    formateDate(num) {
      return num.toString().length < 2 ? `0${num}` : 0 + num;
    },
  },
};
</script>


<style lang="scss" scoped>
// NOTICE:offsetTop-返回距离当前元素最近的采用定位的祖先元素，如果祖先元素中没有采用定位的元素，则返回body元素。

@import "../css/common.scss";
.platform {
  // @include boxsize(710, 1089);
  width: trans(710);
  margin: 0 auto;
  margin-top: trans(-35);
  box-sizing: border-box;
}
.vip_icon {
  @include boxsize(290, 62);
  margin-left: trans(147);
  img {
    width: 100%;
    display: block;
  }
}

.platform_display {
  // @include boxsize(710, 1027);
  width: trans(710);
  background-color: #ff4031;
  border-radius: trans(50);
  margin-top: trans(-1);
  overflow: hidden;
  padding-bottom: trans(20);
  .display_inner {
    // @include boxsize(690, 823);
    width: trans(690);
    background-color: #fff;
    border-radius: trans(50);
    margin: 0 auto;
    margin-top: trans(10);
    overflow: hidden;
  }
  .display_layout_top {
    @include boxsize(690, 203);
    @include bgimg("../img/platform-display-top-bg.png", 100%, 100%);
    @include layout(flex-start, flex-start);
    overflow: hidden;
    .kuaikan_icon_container {
      @include boxsize(136, 181);
      overflow: hidden;
      margin-top: trans(18);
      margin-left: trans(52);
      .kuaikan_icon_bg {
        @include boxsize(136, 75);
        display: block;
        margin-top: trans(106);
      }
      .kuaikan_icon {
        @include boxsize(128, 128);
        display: block;
        margin: 0 auto;
        margin-top: trans(-182);
      }
    }
    .slogan_container {
      width: trans(448);
      margin-left: trans(28);
      margin-top: trans(35);
    }
    .platform_tips {
      @include fontstyle(#9e8c8a, 20);
      width: trans(451);
      text-align: center;
      line-height: 1.15;
      margin-top: trans(10);
    }
    .slogan_icon {
      @include boxsize(448, 71);
      img {
        @include boxsize(448, 71);
        display: block;
      }
    }
    .progress_container {
      @include boxsize(451, 36);
      @include layout(center, center);
      background-color: #ff4747;
      border-radius: trans(18);
      margin-top: trans(14);
      position: relative;
    }
    .progress_wrap {
      @include boxsize(443, 36);
      @include vcenter(36);
      position: absolute;
      left: trans(4);
      // top: trans(4);
      .progress_inner {
        // @include vcenter(28);
        position: absolute;
        // left: trans(4);
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 1%;
        height: trans(28);
        background-color: #fed531;
        border-radius: trans(18);
        transition: all 0.5s linear;
      }
      .progress_end {
        width: 100%;
      }
      .got_num {
        @include fontstyle(#4a2525, 22);
        // @include vcenter(36);
        font-weight: bold;
        position: absolute;
        line-height: 1.15;
        left: trans(38);
        // top: trans(7);
        top: 50%;
        transform: translateY(-50%);
      }
      .left_num {
        @include fontstyle(#4a2525, 22);
        font-weight: bold;
        position: absolute;
        line-height: 1.15;
        right: trans(28);
        top: 50%;
        transform: translateY(-50%);
        // top: trans(7);
      }
    }

    .slogan_tips {
      @include fontstyle(#fff, 22);
      width: trans(451);
      // line-height: trans(36);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      text-align: center;
      font-weight: bold;
    }
  }
  .display_layout_bottom {
    // @include bgimg("../img/platform-display-bottom-bg.png", 100%, 100%);
    // @include boxsize(690, 620);
    width: trans(690);
    min-height: trans(100);
    overflow: hidden;
    padding-bottom: trans(20);
    background-color: #fffdf8;
    .display_layout_inner_nine {
      @include boxsize(600, 580);
      @include layout(space-between, center);
      margin: 0 auto;
      margin-top: trans(18);
    }
    .display_item {
      @include boxsize(190, 180);
      @include layout(center, center);
      // border: 1px solid #000;
      .display_icon {
        @include boxsize(128, 128);
        display: block;
        margin-bottom: trans(-5);
      }
      .plat_title {
        @include fontstyle(#422222, 26);
        // @include textellipsis();
        width: 100%;
        max-width: trans(190);
        line-height: 1.15;
        font-weight: bold;
        text-align: center;
        white-space: nowrap;
      }
      .plat_desc {
        @include fontstyle(#9e8c8a, 20);
        line-height: 1.15;
        text-align: center;
        margin-top: trans(2);
      }
    }
  }

  .tips_container {
    @include boxsize(650, 22);
    @include layout(space-between, center);
    @include fontstyle(#fff, 22);
    line-height: 1.15;
    margin: 0 auto;
    margin-top: trans(14);
  }
  .tips_center {
    width: 100%;
    justify-content: center;
  }
}
.open_btn {
  @include boxsize(653, 100);
  margin: 0 auto;
  margin-top: trans(30);
}

.display_layout_inner_ten {
  width: trans(690);
  margin: 0 auto;
  .inner_ten_top {
    @include boxsize(600, 110);
    @include layout(space-between, center);
    margin: 0 auto;
    margin-top: trans(20);
    .inner_ten_top_item {
      @include layout(flex-start, center);
      width: trans(268);
      flex-wrap: nowrap;
    }
    .inner_ten_icon {
      @include boxsize(110, 110);
      img {
        width: trans(110);
        display: block;
      }
    }
    .inner_ten_info {
      .inner_ten_title {
        @include fontstyle(#422222, 26);
        line-height: 1.15;
        font-weight: bold;
        white-space: nowrap;
      }
      .inner_ten_desc {
        @include fontstyle(#9e8c8a, 22);
        line-height: 1.15;
        margin-top: trans(6);
      }
    }
  }
  .inner_ten_bottom {
    @include layout(space-between, center);
    width: trans(640);
    margin: 0 auto;
    margin-top: trans(10);
    .inner_ten_bottom_item {
      @include boxsize(143, 150);
      @include layout(center, flex-start);
      margin-bottom: trans(30);
    }
    .inner_ten_bottom_icon {
      @include boxsize(110, 110);
      img {
        width: 100%;
        display: block;
      }
    }
    .inner_ten_bottom_info {
      .inner_ten_bottom_title {
        @include fontstyle(#422222, 24);
        line-height: 1.15;
        font-weight: bold;
        text-align: center;
        white-space: nowrap;
      }
      .inner_ten_bottom_desc {
        @include fontstyle(#9e8c8a, 22);
        line-height: 1.15;
        margin-top: trans(6);
        text-align: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/Platform.vue